import apiClient from "../../axios/apiClient";


export const getHospitalList =
  (token, limit = 10, page = 1, search = "", sort = "desc",filters) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HOSPITALLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Hospital`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            filters:filters,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_HOSPITALLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_HOSPITALLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveHospitalData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_HOSPITAL_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Hospital`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_HOSPITAL_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_HOSPITAL_REJECTED", payload: error.response });
    }
  };
  

  export const getHospitalListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HOSPITALLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Hospital/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_HOSPITALLISTBYID_FULFILLED",
        payload: response.data?.data,
        vehicleCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_HOSPITALLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateHospitalData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_HOSPITAL_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Hospital/${id}`, // Endpoint URL with HOSPITAL ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_HOSPITAL_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_HOSPITAL_REJECTED", payload: error.response });
  }
};

export const updateHospitalStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_HOSPITAL_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Hospital-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_HOSPITAL_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_HOSPITAL_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteHospitalData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_HOSPITAL_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Hospital/${id}`, // Endpoint URL with HOSPITAL ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_HOSPITAL_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_HOSPITAL_REJECTED", payload: error.response });
  }
};